<template>
    <transition name="modal">
        <div v-if="isOpen" :class="{ menu: true, isCatalog: isCatalog }">
            <div class="menu__content">
                <div v-if="isCatalog" class="menu__content__catalog">
                    <h2>{{ $t('catalog') }}</h2>
                    <div class="menu__content__catalog__container" v-for="item in categories">
                        <MyAccordion
                            class="menu__content__catalog__container__accordion"
                            v-if="item?.subcategories?.length"
                            type="catalog"
                            :key="'accordion' + item.id"
                            :title="item.categoryTitle"
                        >
                            <MyLink
                                class="menu__content__catalog__container__accordion__link"
                                v-for="(el, idx) in item.subcategories"
                                :to="localePath({ path: `/${el.subCategoryUrl}` })"
                                :title="el.subCategoryTitle"
                                :key="'sublink' + el.id"
                            />
                        </MyAccordion>

                        <MyLink
                            class="menu__content__catalog__container__link"
                            v-else
                            :to="localePath({ path: `/${item.categoryUrl}` })"
                            :title="item.categoryTitle"
                            :key="'link' + item.id"
                        />
                    </div>
                </div>
                <div v-else class="menu__content__links">
                    <!-- <div v-for="(item, idx) in menuItems" :key="idx">
                        <MyActionBtn
                            v-if="item.scroll"
                            class="menu__content__links__btn"
                            :btnText="item.title"
                            :theme="'transparent'"
                            :type="'text'"
                            @click="scrollToFaq"
                        />
                        <div v-else-if="item.static" :style="{ display: 'flex', gap: '10px' }">
                            <MyLink
                                :class="{ menu__content__links__link: true, static: true }"
                                :to="item.link"
                                :title="item.title"
                                @click="close"
                            />
                            <img
                                width="24px"
                                :src="require('@/themes/ecaterix/assets/icons/want-to-order-icon.svg')"
                                alt="want-to-order-icon"
                            />
                        </div>
                        <MyLink v-else :to="item.link" :title="item.title" @click="close" />
                    </div> -->

                    <div
                        v-for="item in globalSettings.header_pages"
                        :key="item.id + 'mobileNav'"
                        v-if="item.is_active"
                        :style="{
                            display: 'flex',
                            gap: '5px',
                            flexDirection: item.position === 'left' ? 'row-reverse' : 'row',
                            width: 'max-content'
                        }"
                    >
                        <MyLink :to="item.link" tag="a" :dynamicData="item" dynamicMobileSize="24px" :title="item.column_name" />
                        <img v-if="item.icon" width="24px" :style="{ 'object-fit': 'contain' }" :src="item.icon" />
                    </div>
                </div>

                <div v-if="!isCatalog" class="menu__content__footer">
                    <div class="menu__content__footer__phone">
                        <button />
                        <a :href="`tel:${mainPhoneNumber}`">{{ mainPhoneNumber }}</a>
                    </div>
                    <div class="menu__content__footer__phone" v-if="stationaryPhoneNumber">
                        <button />
                        <a :href="`tel:${stationaryPhoneNumber}`">{{ stationaryPhoneNumber }}</a>
                    </div>

                    <div
                        class="menu__content__footer__lang"
                        v-click-outside="
                            () => {
                                this.closeLangMenu();
                            }
                        "
                    >
                        <button @click="isShowLangMenu = !isShowLangMenu" type="button">
                            <a>{{ currentLocaleName }}</a>
                            <svg><use :xlink:href="iconLink('arrowRight')"></use></svg>
                            <ul :class="{ show: isShowLangMenu }">
                                <li v-for="locale in $i18n.locales" :key="locale.code">
                                    <NuxtLink
                                        prefetch
                                        :to="switchLocalePath(locale.code)"
                                        :class="{ current: locale.code === $i18n.locale }"
                                    >
                                        {{ locale.name }}
                                    </NuxtLink>
                                </li>
                            </ul>
                        </button>
                    </div>
                </div>

                <button :class="{ menu__content__close: true, isCatalog: isCatalog }" title="X" type="button" @click="close">
                    <svg><use :xlink:href="iconLink('close')"></use></svg>
                </button>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            isShowLangMenu: false,
            menuItems: []
        };
    },
    components: {
        MyLink: () => import('@/themes/ecaterix/components/ui/MyLinkBtn'),
        MyAccordion: () => import('@/themes/ecaterix/components/ui/MyAccordion'),
        MyActionBtn: () => import('@/themes/ecaterix/components/ui/MyActionBtn')
    },
    computed: {
        ...mapGetters({
            isOpen: 'mobile-menu/getIsOpen',
            activeTab: 'mobile-menu/getActiveTab',
            mainPhoneNumber: 'global/mainPhoneNumber',
            categories: 'categories/getCategories',
            stationaryPhoneNumber: 'global/stationaryPhoneNumber',
            globalSettings: 'global/globalSettings',
            getCurrentTheme: 'global/getCurrentTheme'
        }),
        isCatalog() {
            return this.activeTab === 'catalog';
        },
        currentLocaleName() {
            return this.$i18n.locales.filter(i => i.code === this.$i18n.locale)[0]?.name;
        }
    },
    watch: {
        '$i18n.locale': {
            handler(e) {
                this.menuItems = [
                    { title: this.$t('aboutUs'), link: this.localePath('/about') },
                    { title: this.$t('blog'), link: this.localePath('/articles') },
                    { title: this.$t('partners'), link: this.localePath('/partners') },
                    { title: this.$t('reviews'), link: this.localePath('/feedbacks') },
                    { title: this.$t('gallery'), link: this.localePath('/gallery') },
                    { title: this.$t('logistics'), link: this.localePath('/logistics') },
                    { title: this.$t('faq'), link: this.localePath('/#faq'), scroll: true },
                    { title: this.$t('contacts'), link: this.localePath('/contacts') },
                    { title: this.$t('wantToOrder'), link: this.localePath('/want-to-order'), static: true }
                ];
            },
            immediate: true,
            deep: true
        },
        $route: {
            handler() {
                this.close();
            }
        },
        isOpen(newVal) {
            this.setScrollBlocker(newVal);
        }
    },
    methods: {
        closeLangMenu() {
            this.isShowLangMenu = false;
        },
        setScrollBlocker(flag) {
            document.body.classList[flag ? 'add' : 'remove']('--blocked');
        },
        smoothScrollTo(element, duration = 1000, offset = 0) {
            const targetPosition = element.getBoundingClientRect().top + window.scrollY;
            const startTime = performance.now();

            const easeInOutQuad = t => {
                return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            };

            const animateScroll = currentTime => {
                const elapsedTime = currentTime - startTime;
                const progress = Math.min(elapsedTime / duration, 1);
                const easing = easeInOutQuad(progress);
                const scrollPosition = targetPosition * easing;
                window.scrollTo(0, scrollPosition);

                if (elapsedTime < duration) {
                    requestAnimationFrame(animateScroll);
                }
            };

            requestAnimationFrame(animateScroll);
        },
        smoothScroll() {
            this.$nextTick(() => {
                const faqElement = document.querySelector('.questions-scroll');
                if (faqElement) {
                    this.smoothScrollTo(faqElement, 1500, 50);
                } else {
                    this.waitForElement('.questions-scroll', 1000).then(element => {
                        this.smoothScrollTo(element, 1500, 50);
                    });
                }
            });
        },
        scrollToFaq() {
            this.close();

            if (this.$route.path === this.localePath('/')) {
                this.smoothScroll();
            } else {
                this.$router
                    ?.replace(this.localePath('/'))
                    .then(() => {
                        this.smoothScroll();
                    })
                    .catch(error => {
                        this.smoothScroll();
                    });
            }
        },
        waitForElement(selector, interval = 100, timeout = 5000) {
            return new Promise((resolve, reject) => {
                const startTime = new Date().getTime();

                const timer = setInterval(() => {
                    const element = document.querySelector(selector);

                    if (element) {
                        clearInterval(timer);
                        resolve(element);
                    } else {
                        const elapsedTime = new Date().getTime() - startTime;
                        if (elapsedTime >= timeout) {
                            clearInterval(timer);
                            reject(new Error('Element not found within timeout'));
                        }
                    }
                }, interval);
            });
        },
        close() {
            this.$store.dispatch('mobile-menu/setIsOpen', false);
        },
        iconLink(icon) {
            const spritePath = require('@/themes/ecaterix/assets/icons/sprite.svg');
            return `${spritePath}#${icon}`;
        }
    }
};
</script>
<style lang="scss" scoped>
@import '~/themes/ecaterix/assets/styles/utils.scss';
@import './styles';
</style>
